import { UtilService } from "./../helpers/util-service";
import { FuseUtil } from "./../helpers/fuse-utils";
import { RepoModel } from "../model/repo-model";
import { FuseErrorUtils, FuseGenericError } from "./../helpers/errors";
import Joi from "joi";
import { getJoiValidationErrors } from "../helpers/base-joi-helper";
import { coreSchemaDefinition } from "../core/base-schema";
import { DynamoManageTable } from "./dynamo-manage-table";
import { LoggingService } from "../helpers/logging-service";
import { DynamoFilterQueryOperation } from "./dynamo-filter-query-operation";
import { DynamoQueryScanProcessor } from "./dynamo-query-scan-processor";
function createTenantSchema(schemaMapDef) {
    return Joi.object().keys({
        ...schemaMapDef,
        ...coreSchemaDefinition,
    });
}
export class DynamoDataOperation extends RepoModel {
    constructor({ schemaDef, dynamoDb, secondaryIndexOptions, featureEntityValue, baseTableName, strictRequiredFields, dataKeyGenerator, }) {
        super();
        Object.defineProperty(this, "_fuse_partitionKeyFieldName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "id"
        });
        Object.defineProperty(this, "_fuse_sortKeyFieldName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "featureEntity"
        });
        Object.defineProperty(this, "_fuse_featureEntity_Key_Value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_dynamoDb", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_dataKeyGenerator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_tableFullName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_strictRequiredFields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_featureEntityValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_secondaryIndexOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_queryFilter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_queryScanProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_errorHelper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_tableManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._fuse_dynamoDb = dynamoDb;
        this._fuse_dataKeyGenerator = dataKeyGenerator;
        this._fuse_schema = createTenantSchema(schemaDef);
        this._fuse_tableFullName = baseTableName;
        this._fuse_featureEntityValue = featureEntityValue;
        this._fuse_secondaryIndexOptions = secondaryIndexOptions;
        this._fuse_strictRequiredFields = strictRequiredFields;
        this._fuse_queryFilter = new DynamoFilterQueryOperation();
        this._fuse_queryScanProcessor = new DynamoQueryScanProcessor();
        this._fuse_errorHelper = new FuseErrorUtils();
        this._fuse_featureEntity_Key_Value = { featureEntity: featureEntityValue };
    }
    fuse_tableManager() {
        if (!this._fuse_tableManager) {
            this._fuse_tableManager = new DynamoManageTable({
                dynamoDb: () => this._fuse_dynamoDbInstance(),
                secondaryIndexOptions: this._fuse_secondaryIndexOptions,
                tableFullName: this._fuse_tableFullName,
                partitionKeyFieldName: this._fuse_partitionKeyFieldName,
                sortKeyFieldName: this._fuse_sortKeyFieldName,
            });
        }
        return this._fuse_tableManager;
    }
    _fuse_dynamoDbInstance() {
        return this._fuse_dynamoDb().getInstance();
    }
    _fuse_generateDynamoTableKey() {
        return this._fuse_dataKeyGenerator();
    }
    _fuse_getLocalVariables() {
        return {
            partitionKeyFieldName: this._fuse_partitionKeyFieldName,
            sortKeyFieldName: this._fuse_sortKeyFieldName,
            featureEntityValue: this._fuse_featureEntityValue,
            tableFullName: this._fuse_tableFullName,
            secondaryIndexOptions: this._fuse_secondaryIndexOptions,
            strictRequiredFields: this._fuse_strictRequiredFields,
        };
    }
    _fuse_getBaseObject({ dataId }) {
        const { partitionKeyFieldName, sortKeyFieldName, featureEntityValue } = this._fuse_getLocalVariables();
        const dataMust = {
            [partitionKeyFieldName]: dataId,
            [sortKeyFieldName]: featureEntityValue,
        };
        return dataMust;
    }
    _fuse_checkValidateMustBeAnObjectDataType(data) {
        if (!data || typeof data !== "object") {
            throw this._fuse_createGenericError(`Data MUST be valid object`);
        }
    }
    _fuse_checkValidateStrictRequiredFields(onDataObj) {
        this._fuse_checkValidateMustBeAnObjectDataType(onDataObj);
        const { strictRequiredFields } = this._fuse_getLocalVariables();
        if (strictRequiredFields?.length) {
            for (const field of strictRequiredFields) {
                if (onDataObj[field] === null || onDataObj[field] === undefined) {
                    throw this._fuse_createGenericError(`Strict required field NOT defined`);
                }
            }
        }
    }
    _fuse_createGenericError(error) {
        return new FuseGenericError(error);
    }
    _fuse_withConditionPassed({ item, withCondition }) {
        if (item && typeof item === "object" && withCondition?.length) {
            const isPassed = withCondition.every(({ field, equals }) => {
                return item[field] !== undefined && item[field] === equals;
            });
            return isPassed;
        }
        return true;
    }
    _fuse_removeDuplicateString(strArray) {
        return Array.from(new Set([...strArray]));
    }
    async _fuse_allHelpValidateMarshallAndGetValue(data) {
        const { error, value } = this._fuse_schema.validate(data, {
            stripUnknown: true,
        });
        if (error) {
            const msg = getJoiValidationErrors(error) ?? "Validation error occured";
            throw this._fuse_errorHelper.fuse_helper_createFriendlyError(msg);
        }
        const marshalledData = FuseUtil.fuse_marshallFromJson(value);
        return await Promise.resolve({
            validatedData: value,
            marshalled: marshalledData,
        });
    }
    async fuse_createOne({ data }) {
        this._fuse_checkValidateStrictRequiredFields(data);
        const { tableFullName, partitionKeyFieldName, featureEntityValue } = this._fuse_getLocalVariables();
        let dataId = data[partitionKeyFieldName];
        if (!dataId) {
            dataId = this._fuse_generateDynamoTableKey();
        }
        if (!(dataId && typeof dataId === "string")) {
            throw this._fuse_createGenericError("Invalid dataId generation");
        }
        const dataMust = this._fuse_getBaseObject({ dataId });
        const fullData = { ...data, ...dataMust };
        if (fullData.featureEntity !== featureEntityValue) {
            throw this._fuse_createGenericError("FeatureEntity mismatched");
        }
        const { validatedData, marshalled } = await this._fuse_allHelpValidateMarshallAndGetValue(fullData);
        const params = {
            TableName: tableFullName,
            Item: marshalled,
        };
        await this._fuse_dynamoDbInstance().putItem(params);
        const result = validatedData;
        return result;
    }
    async fuse_getOneById({ dataId, withCondition, }) {
        const { partitionKeyFieldName, sortKeyFieldName, featureEntityValue, tableFullName, } = this._fuse_getLocalVariables();
        this._fuse_errorHelper.fuse_helper_validateRequiredString({
            QueryGetOnePartitionKey: dataId,
            QueryGetOneSortKey: featureEntityValue,
        });
        const params = {
            TableName: tableFullName,
            Key: {
                [partitionKeyFieldName]: { S: dataId },
                [sortKeyFieldName]: { S: featureEntityValue },
            },
        };
        const result = await this._fuse_dynamoDbInstance().getItem(params);
        const item = result.Item;
        if (!item) {
            return null;
        }
        const isPassed = this._fuse_withConditionPassed({ withCondition, item });
        if (!isPassed) {
            return null;
        }
        return item;
    }
    async fuse_updateOne({ dataId, updateData, withCondition, }) {
        this._fuse_checkValidateStrictRequiredFields(updateData);
        const { tableFullName, partitionKeyFieldName, sortKeyFieldName } = this._fuse_getLocalVariables();
        this._fuse_errorHelper.fuse_helper_validateRequiredString({ Update1DataId: dataId });
        const dataInDb = await this.fuse_getOneById({ dataId });
        if (!dataInDb?.[partitionKeyFieldName]) {
            throw this._fuse_errorHelper.fuse_helper_createFriendlyError("Data does NOT exists");
        }
        if (dataInDb?.[sortKeyFieldName] !== this._fuse_featureEntityValue) {
            throw this._fuse_createGenericError("Record does not exists");
        }
        const isPassed = this._fuse_withConditionPassed({
            withCondition,
            item: dataInDb,
        });
        if (!isPassed) {
            throw this._fuse_createGenericError("Update condition failed");
        }
        const dataMust = this._fuse_getBaseObject({ dataId });
        const fullData = {
            ...dataInDb,
            ...updateData,
            ...dataMust,
        };
        const { validatedData, marshalled } = await this._fuse_allHelpValidateMarshallAndGetValue(fullData);
        const params = {
            TableName: tableFullName,
            Item: marshalled,
        };
        await this._fuse_dynamoDbInstance().putItem(params);
        const result = validatedData;
        return result;
    }
    async fuse_getManyByIds({ dataIds, fields, withCondition, }) {
        dataIds.forEach((dataId) => {
            this._fuse_errorHelper.fuse_helper_validateRequiredString({
                BatchGetDataId: dataId,
            });
        });
        const originalIds = this._fuse_removeDuplicateString(dataIds);
        const BATCH_SIZE = 80;
        const batchIds = [];
        while (originalIds.length > 0) {
            const ids = originalIds.splice(0, BATCH_SIZE);
            batchIds.push(ids);
        }
        LoggingService.log("@fuse_getManyByIds batchIds: ", batchIds.length);
        let result = [];
        const fieldKeys = fields?.length ? this._fuse_removeDuplicateString(fields) : fields;
        for (const batch of batchIds) {
            const call = await this.fuse_batchGetManyByIdsBasePrivate({
                dataIds: batch,
                fields: fieldKeys,
                withCondition,
            });
            result = [...result, ...call];
        }
        LoggingService.log("@fuse_getManyByIds batchIds result Out: ", result.length);
        return result;
    }
    async fuse_batchGetManyByIdsBasePrivate({ dataIds, fields, withCondition, }) {
        return new Promise((resolve, reject) => {
            const getRandom = () => [
                "rand",
                Math.round(Math.random() * 99999),
                Math.round(Math.random() * 88888),
                Math.round(Math.random() * 99),
            ].join("");
            const { tableFullName, partitionKeyFieldName, sortKeyFieldName, featureEntityValue, } = this._fuse_getLocalVariables();
            const dataIdsNoDup = this._fuse_removeDuplicateString(dataIds);
            const getArray = dataIdsNoDup.map((dataId) => {
                const params01 = {
                    [partitionKeyFieldName]: { S: dataId },
                    [sortKeyFieldName]: { S: featureEntityValue },
                };
                return params01;
            });
            let projectionExpression = undefined;
            let expressionAttributeNames = undefined;
            if (fields?.length) {
                const fieldKeys = this._fuse_removeDuplicateString(fields);
                if (withCondition?.length) {
                    withCondition.forEach((condition) => {
                        if (!fieldKeys.includes(condition.field)) {
                            fieldKeys.push(condition.field);
                        }
                    });
                }
                expressionAttributeNames = {};
                fieldKeys.forEach((fieldName) => {
                    if (typeof fieldName === "string") {
                        if (expressionAttributeNames) {
                            const attrKeyHash = `#attrKey${getRandom()}k`.toLowerCase();
                            expressionAttributeNames[attrKeyHash] = fieldName;
                        }
                    }
                });
                if (Object.keys(expressionAttributeNames)?.length) {
                    projectionExpression = Object.keys(expressionAttributeNames).join(",");
                }
                else {
                    projectionExpression = undefined;
                    expressionAttributeNames = undefined;
                }
            }
            const params = {
                RequestItems: {
                    [tableFullName]: {
                        Keys: [...getArray],
                        ConsistentRead: true,
                        ProjectionExpression: projectionExpression,
                        ExpressionAttributeNames: expressionAttributeNames,
                    },
                },
            };
            let returnedItems = [];
            const resolveItemResults = (resultItems) => {
                if (resultItems?.length && withCondition?.length) {
                    return resultItems.filter((item) => {
                        return withCondition.every((condition) => {
                            return item[condition.field] === condition.equals;
                        });
                    });
                }
                return resultItems || [];
            };
            const batchGetUntilDone = (err, data) => {
                if (err) {
                    if (returnedItems?.length) {
                        resolve(resolveItemResults(returnedItems));
                    }
                    else {
                        reject(err?.stack);
                    }
                }
                else {
                    if (data?.Responses) {
                        const itemListRaw = data.Responses[tableFullName];
                        if (itemListRaw?.length) {
                            const itemList = itemListRaw.map((item) => {
                                return FuseUtil.fuse_unmarshallToJson(item);
                            });
                            returnedItems = [...returnedItems, ...itemList];
                        }
                    }
                    if (data?.UnprocessedKeys && Object.keys(data.UnprocessedKeys).length) {
                        const _params = {
                            RequestItems: data.UnprocessedKeys,
                        };
                        LoggingService.log({ dynamoBatchGetParams: _params });
                        this._fuse_dynamoDbInstance().batchGetItem(params, (err, resultData) => {
                            batchGetUntilDone(err, resultData);
                        });
                    }
                    else {
                        resolve(resolveItemResults(returnedItems));
                    }
                }
            };
            this._fuse_dynamoDbInstance().batchGetItem(params, (err, resultData) => {
                batchGetUntilDone(err, resultData);
            });
        });
    }
    async fuse_getManyBySecondaryIndex(paramOption) {
        const result = await this._fuse_getManyBySecondaryIndexPaginateBase(paramOption, false);
        if (result?.mainResult) {
            return result.mainResult;
        }
        return [];
    }
    async fuse_getManyBySecondaryIndexPaginate(paramOption) {
        return this._fuse_getManyBySecondaryIndexPaginateBase(paramOption, true);
    }
    async _fuse_getManyBySecondaryIndexPaginateBase(paramOption, canPaginate) {
        const { tableFullName, secondaryIndexOptions } = this._fuse_getLocalVariables();
        if (!secondaryIndexOptions?.length) {
            throw this._fuse_createGenericError("Invalid secondary index definitions");
        }
        if (!paramOption?.indexName) {
            throw this._fuse_createGenericError("Invalid index name input");
        }
        const secondaryIndex = secondaryIndexOptions.find((item) => {
            return item.indexName === paramOption.indexName;
        });
        if (!secondaryIndex) {
            throw this._fuse_createGenericError("Secondary index not named/defined");
        }
        const index_PartitionKeyFieldName = secondaryIndex.partitionKeyFieldName;
        const index_SortKeyFieldName = secondaryIndex.sortKeyFieldName;
        const partitionSortKeyQuery = paramOption.sortKeyQuery
            ? {
                ...{ [index_SortKeyFieldName]: paramOption.sortKeyQuery },
                ...{ [index_PartitionKeyFieldName]: paramOption.partitionKeyValue },
            }
            : { [index_PartitionKeyFieldName]: paramOption.partitionKeyValue };
        const fieldKeys = paramOption.fields?.length ? this._fuse_removeDuplicateString(paramOption.fields) : undefined;
        const localVariables = this._fuse_getLocalVariables();
        const hasFeatureEntity = [
            index_PartitionKeyFieldName,
            index_SortKeyFieldName,
        ].includes(localVariables.sortKeyFieldName);
        if (!hasFeatureEntity) {
            paramOption.query = (paramOption.query || {});
            paramOption.query = {
                ...paramOption.query,
                ...this._fuse_featureEntity_Key_Value,
            };
        }
        else if (index_PartitionKeyFieldName !== localVariables.sortKeyFieldName) {
            if (localVariables.sortKeyFieldName === index_SortKeyFieldName) {
                partitionSortKeyQuery[index_SortKeyFieldName] = { $eq: localVariables.featureEntityValue };
            }
        }
        const mainFilter = this._fuse_queryFilter.processQueryFilter({
            queryDefs: partitionSortKeyQuery,
            projectionFields: fieldKeys,
        });
        let otherFilterExpression = undefined;
        let otherExpressionAttributeValues = undefined;
        let otherExpressionAttributeNames = undefined;
        if (paramOption.query) {
            const otherFilter = this._fuse_queryFilter.processQueryFilter({
                queryDefs: paramOption.query,
                projectionFields: null,
            });
            otherExpressionAttributeValues = otherFilter.expressionAttributeValues;
            otherExpressionAttributeNames = otherFilter.expressionAttributeNames;
            if (otherFilter?.filterExpression?.length && otherFilter?.filterExpression.length > 1) {
                otherFilterExpression = otherFilter.filterExpression;
            }
        }
        const params = {
            TableName: tableFullName,
            IndexName: paramOption.indexName,
            KeyConditionExpression: mainFilter.filterExpression,
            ExpressionAttributeValues: {
                ...otherExpressionAttributeValues,
                ...mainFilter.expressionAttributeValues,
            },
            FilterExpression: otherFilterExpression ?? undefined,
            ExpressionAttributeNames: {
                ...otherExpressionAttributeNames,
                ...mainFilter.expressionAttributeNames,
            },
        };
        const orderDesc = paramOption?.sort === "desc";
        if (orderDesc) {
            params.ScanIndexForward = false;
        }
        else {
            params.ScanIndexForward = true;
        }
        if (mainFilter.projectionExpressionAttr) {
            params.ProjectionExpression = mainFilter.projectionExpressionAttr;
        }
        const partitionAndSortKey = [index_PartitionKeyFieldName, index_SortKeyFieldName];
        const result = await this._fuse_queryScanProcessor.fuse__helperDynamoQueryProcessor({
            dynamoDb: () => this._fuse_dynamoDbInstance(),
            params,
            orderDesc,
            partitionAndSortKey,
            evaluationLimit: paramOption.pagingParams?.evaluationLimit,
            nextPageHash: paramOption.pagingParams?.nextPageHash,
            resultLimit: UtilService.isNumberic(paramOption.limit) ? Number(paramOption.limit) : undefined,
            canPaginate,
        });
        return result;
    }
    async fuse_deleteById({ dataId, withCondition, }) {
        this._fuse_errorHelper.fuse_helper_validateRequiredString({ Del1SortKey: dataId });
        const { tableFullName, partitionKeyFieldName, sortKeyFieldName, featureEntityValue, } = this._fuse_getLocalVariables();
        const dataExist = await this.fuse_getOneById({ dataId, withCondition });
        if (!(dataExist && dataExist[partitionKeyFieldName])) {
            throw this._fuse_errorHelper.fuse_helper_createFriendlyError("Record does NOT exists");
        }
        const params = {
            TableName: tableFullName,
            Key: {
                [partitionKeyFieldName]: { S: dataId },
                [sortKeyFieldName]: { S: featureEntityValue },
            },
        };
        try {
            await this._fuse_dynamoDbInstance().deleteItem(params);
        }
        catch (err) {
            if (err && err.code === "ResourceNotFoundException") {
                throw this._fuse_errorHelper.fuse_helper_createFriendlyError("Table not found");
            }
            else if (err && err.code === "ResourceInUseException") {
                throw this._fuse_errorHelper.fuse_helper_createFriendlyError("Table in use");
            }
            else {
                throw err;
            }
        }
        return dataExist;
    }
}
